// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
export const isPositiveDecimal = (amount: string) => {
  const val = parseFloat(amount);
  return val >= 0;
};
